module.exports = __webpack_public_path__ + "img/goods12_1.f497bfc6.jpg";